import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AnyMxRecord } from 'dns';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContactService } from 'src/app/pages/contacts/services/contact.service';
import { ItemsService } from 'src/app/pages/items/services/items.service';
import { LeadService } from 'src/app/pages/lead/services/lead.service';
import { TasksService } from 'src/app/pages/tasks/services/tasks.service';
import { QuoteTemplateService } from 'src/app/quote-template-new/services/quote-template.service';
import { WidgetService } from 'src/app/widgets/services/widget.service';
import { MatRadioChange } from '@angular/material/radio';
import { BusinessProfileService } from 'src/app/pages/business-profile/services/business-profile.service';

declare let $: any;
export interface FilterCategory {
  name: string;
  selected: boolean;
  showSubcategories?: boolean;
  subcategories?: FilterSubcategory[];
  id: string;
}

export interface FilterSubcategory {
  name: string;
  selected: boolean;
  id: string;
}

export interface FilterValue {
  name: string;
  selected: boolean;
  subcategories?: FilterSubcategory[];
  showSubcategories: boolean;
}

export interface CustomTypeOption {
  label: string;
  svg: string;
}

export interface FilterData {
  filterName: string;
  selectedCategoriesId: string[];
  selectedSubcategoryId: string[];
  values: string[];
  selectedCustomType: string;
  selectedMembers:  string[];
  startDate?: Date;
  endDate?: Date;
  dealValues: string[];
  itemValues:string[];
  selectedTags:string[];
  selectedDealTagsIds:string[];
  contactSource:string[];
  selectedContactTags:string[];
  selectedStages:string[];
  selectedTax:string[];
  region:string[];
  selectedDealTags:string[];
  selectedLeadTags:string[];
  selectedDateRange?: string;
  dealReasons:string[];
  Organization:string[];
  contactSelected:string[];
  selectedStatus:string[];
  selectedQuoteStatus:string[];
  deal_stage_id:string[];
  deal_type_id:string[];
  selectedLimit:string[];
  selectedMetric:string;
  selectedInteraction:string;
  selectedAxis:string;
  selectedViews:string;
}

@Component({
    selector: 'app-common-filter',
    templateUrl: './common-filter.component.html',
    styleUrls: ['./common-filter.component.scss'],
    standalone: false
})
export class CommonFilterComponent implements OnInit,OnChanges, OnDestroy {
  accountStatementStatusFilter = [
    { id: 1, name: 'Past Due', checked: false },
    { id: 2, name: 'Due', checked: false },
    { id: 4, name: 'Due Today', checked: false }
  ];
  quoteBySourceStatusFilters = [
    { id: 1, name: 'Accepted', checked: false },
    { id: 2, name: 'Rejected', checked: false },
  ];
  allQuoteStagesList: any[]=[];
  allLeadsTagsArr: any[]=[];
  currencyArr: any[]=[];
  filteredCurrency: any[]=[];
  searchValue:any;
  deal_typeArr: any[] = [];
  deal_stageArr: any[] = [];
  activityArr: any[] = [];
  selectedMember: any[] = [];
  selectedStatus: any[] = [];
  selectedQuoteStatus:any[]=[];
  taxListArr:any[]=[];
  appliedChips:any[]=[];
  selectedContacts: { id: any; name: string; }[] = [];
  globalSearchText: any = '';
  currentPage:any=0
  sortField: any = 'created_at';
  sortOrder: any = 'DESC';
  where: any;  isLoading: boolean = false;  serchArr: any = {};page: any = {
    currentPage: 1,
    pageSize: 10,
  }
  merContactListArrNew:any=[]
  limit:any;
  originalMerContactListArr: any[];
itemActivePagination = Array();
openBulkAction: boolean = false;
  private _unsubscribeAll: Subject<any> = new Subject();
  @Input() filterName: string = '';
  @Input() selectedCustomType: string = 'Wave';
  @Input() customTypeOptions: CustomTypeOption[] = [];
  @Input() categories: FilterCategory[] = [];
  @Input() values: any = [];
  @Input() reportFilterData: any = '';
  @Input() dateRangeOptions: { label: string; value: string }[] = [
    { label: 'Next 30 Days', value: 'next_30_days' },
    { label: 'Next 60 Days', value: 'next_60_days' },
    { label: 'Next 90 Days', value: 'next_90_days' },
  ];
  salesMetrics = [
    { name: 'Top sellers' },
    { name: 'Highest average sale' },
    { name: 'Most consistent performers (Conversion)' },
    { name: 'Top commission earners' }
  ];

  interactionsArray = [
    { name: 'Accepted' },
    { name: 'Rejected' }
  ];

  yAxis = [
    { label: 'Value $', value: 'Value $' }, // both label and value same
    { label: '', value: 'Sales Orders (Quantity)' } // label dynamic, value fixed
  ];
  

  viewCurrency = [
    { name: 'View in Currency' },
    { name: 'View in Numbers' }
  ];
  
  selectedMetric: string | null = null;
  selectedInteraction: string | null = null;
  selectedAxis: string | null = null;
  selectedViews: string | null = null;

  
  singale_value = new FormControl();
  @Input() selectedDateRange: string = '';
  @Input() regionArray:any=[]
  @Input() contactTags:any=[]
  @Input() lostDealValues: any = [];  
  @Input() selectedFilterdata;  
  @Output() selectedCustomTypeChange = new EventEmitter<string>();
  @Output() clearFilterClicked = new EventEmitter<string>();
  @Output() applyFilterClicked = new EventEmitter<FilterData>();
  @Output() closeDropdown = new EventEmitter<void>();
  @Output() selectedDateRangeChange = new EventEmitter<string>();
  selectedReasons: { id: string | number; reason: string }[] = [];
  selectedDealValuesList: { value: string }[] = [];
  selectedItemsValuesList: { id: string,name:string }[] = [];
  selectedItems: number[] = [];
  selectedContactTags: number[] = [];
  selectedStages: any[] = [];
  selectedTax: any[] = [];
  selectedCustomerIds: number[] = [];
  selectedDealTags: number[] = [];
  selectedLeadTags: number[] = [];
  selectedDealIds: number[] = [];
  selectedRegions: string[] = [];
  sourceOfContacts=[]
  selectedSource: number[] = [];
  selectedLimit: number[] = [];
  allTagsArr=[]
  topCustomersLimits=[{name:10},{name:20},{name:30},{name:40},{name:50}]
  isCustomTypeDropdownOpen = false;
  customTypeSearch = '';
  filteredCustomTypeOptions: CustomTypeOption[] = [];
  contactSearchTags=''
  itemsSearch=''
  contactSearchTagsNew=''
  merContactListArr:any;
  savedFilter: any = {};
  sliderValue: number = 0;
  sliderMaxValue: number = 0;
  conDummyArr: any[] = [];
  dealValues=[]
  dealReasonsList=[]
  itemsData=[]
  allOrgArr:any=[]
  organizationSearchTags: string = '';
  // Custom date range properties
  startDate?: Date;
  endDate?: Date;
  selectedValue: string = ''; // holds the selected radio value

  onDateRangeChange(value: string) {
    this.selectedDateRange = value;
    this.selectedDateRangeChange.emit(value);
    
    // Clear custom date range when switching to predefined ranges
    if (value !== 'custom_date') {
      this.startDate = undefined;
      this.endDate = undefined;
    }
  }

  // Enforce single-select behavior via checkboxes for date range
  onDateRangeCheckboxChange(event: any, value: string) {
    if (event?.checked) {
      this.onDateRangeChange(value);
    } else {
      // unchecking clears selection
      this.onDateRangeChange('');
    }
    this.generateChips()

  }

  onStartDateChange(event: any) {
    this.startDate = event.value;
    console.log('Start date changed:', this.startDate);
    // ✅ If user picks a custom date, unselect radio
    if (this.startDate) {
      this.selectedDateRange = '';
      this.selectedDateRangeChange.emit('');
    }
  }

  onEndDateChange(event: any) {
    this.endDate = event.value;
    console.log('End date changed:', this.endDate);
    // ✅ If user picks a custom date, unselect radio
    if (this.endDate) {
      this.selectedDateRange = '';
      this.selectedDateRangeChange.emit('');
    }
  }

  async ngOnInit() {
    console.log(this.selectedFilterdata,'selectedFilterdata');
    // console.log(this.reportFilterData, 'reportFilterData');
     console.log(this.filterName,'filterNamefilterNamefilterName');
    //  console.log(this.lostDealValues,'lostDealValueslostDealValues');
    //  console.log(this.regionArray,'regionArrayregionArray');
    //  console.log(this.contactTags,'contactTagscontactTags');
     
      // if (this.regionArray?.length) {
      //   this.regionArray = this.regionArray?.length?.filter(
      //     (item, index, self) =>
      //       index === self.findIndex(
      //         (t) =>
      //           (t.region || t.country)?.toLowerCase().trim() ===
      //           (item.region || item.country)?.toLowerCase().trim()
      //       )
      //   );
      // }
      
     
     if(this.contactTags?.length){
      this.contactTags = this.contactTags.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.id === item.id)
      );
     }
     if(this.filterName =='Lost Deals'){
      this.getLostReasons()
      this.getTags()
     }
     if(this.filterName =='Account statement'){
      this.getOrgList()
      this.getMerchantCustomerNew()
     }
     if(this.filterName =='Won Deal'){
      this.getDealType()
      this.getTags()

      
     }
     
     if(this.filterName=='Sales overview' || this.filterName=='Quote Stages' || this.filterName =='Quote -to-sales-order conversion' || this.filterName =='Commissions' || this.filterName=='Sales Order per Region' || this.filterName=='Sales Order' || this.filterName=='Quote By Source'  || this.filterName =='Top customers' || this.filterName =='Sales Team'){
      await this.itemsNamesAndId()
      this.contactSourceList()
     }
     if(this.filterName =='New Quotes'){
      await this.getQuoteStages()
      this.contactSourceList()
     }
     if(this.filterName =='New Leads'){
      this.getDealType()
      this.contactSourceList()
      this.getTagsLeads()
     }
     if(this.filterName =='Deal Velocity' || this.filterName =='Deal Forecast' || this.filterName =='Lost Deals'){
      this.getDealType()
      this.contactSourceList()
      this.getTags()
      this.contactSourceList()
     }
     if(this.filterName =='Sales Tax'){
      await this.getQuoteStages()
      await this.getTaxList()
     }
     if(this.filterName =='Quote Stage Trend'){
      await this.getQuoteStages()
      this.contactSourceList()
     }
     if(this.filterName === 'Quote -to-sales-order conversion'){
      await this.getCurrency()
     }
     if (this.lostDealValues?.length) {
      this.dealValues = this.lostDealValues.filter(
        (item, index, self) =>
          index === self.findIndex(t => t.value === item.value)
      );
    }
    
     
    this.filteredCustomTypeOptions = [...this.customTypeOptions];
    if(this.filterName =='Quote -to-sales-order conversion'){
      // this.values=[
      //   { name: 'Quotes to sales order conversion', selected: false },
      //   { name: 'Invoices to sales order conversion', selected: false }
      // ]
    }
    // Use filter-specific session storage key
    const filterKey = `appliedFilters_${this.filterName}`;
    await this.getMerchantCustomer()

    if(sessionStorage.getItem(filterKey)) {      
      this.savedFilter = JSON.parse(sessionStorage.getItem(filterKey));
      delete this.savedFilter?.voidQuotes
      console.log(this.savedFilter,'this.savedFilter')
      this.splitValue()
      this.patchValues()
      this.restoreFilterSelections()
    }else{
      this.values.forEach(x=>{
        x.selected=false
      })
      if (this.categories) {
        this.categories.forEach(category => {
          category.selected = false;
          category.showSubcategories = false;
          if (category.subcategories) {
            category.subcategories.forEach(sub => {
              sub.selected = false;
            });
          }
        });
      }
    }
   this.setYAxisOptions()
  }
  constructor(
    public QuoteTemplateServices: QuoteTemplateService,
    private tasksService: TasksService,
    public itemsService:ItemsService,
    public leadService: LeadService,
    private contactService: ContactService,
    private spinnerService: NgxSpinnerService,
    private translateService: TranslateService,
    public businessProfileService: BusinessProfileService,
  ) { }
  checkIfNameMatchesContact(firstName: string, lastName: string): boolean {
    
    return this.savedFilter?.contact?.some(contact => 
      contact?.first_name === firstName && contact?.last_name === lastName
    );
  }
  async getMerchantCustomer(data: any = '') {
    // this.serchArr = {
    //   pagination: true,
    //   limit: this.page?.pageSize,
    //   page: this.page?.currentPage || 1,
    //   whereFilterData: this.where,
    //   search: this.globalSearchText ? this.globalSearchText : '',
    //   sortField: this.sortField,
    //   sortOrder: this.sortOrder
    // };
    const merchantUserListSubs = this.QuoteTemplateServices.merchantUserList({list: 1}).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      if (res.data) {
        // this.currentPage = res.currentPage;
        this.merContactListArr = res.data.map((item: any) => {
          return {
            ...item,
            name:item?.fname,
            checked: this.checkIfNameMatchesContact(item?.fname, item?.lname)
          };
        });
        console.log(this.merContactListArr,"merContactListArr")
      }
    });

  }
  toggleCustomTypeDropdown() {
    this.isCustomTypeDropdownOpen = !this.isCustomTypeDropdownOpen;
  }

  filterCustomTypes() {
    if (this.customTypeSearch.trim()) {
      this.filteredCustomTypeOptions = this.customTypeOptions.filter((option) =>
        option.label.toLowerCase().includes(this.customTypeSearch.toLowerCase())
      );
    } else {
      this.filteredCustomTypeOptions = [...this.customTypeOptions];
    }
  }

  selectCustomType(type: CustomTypeOption) {
    this.selectedCustomType = type.label;
    this.selectedCustomTypeChange.emit(type.label);
    this.isCustomTypeDropdownOpen = false;
    this.customTypeSearch = '';
    this.filteredCustomTypeOptions = [...this.customTypeOptions];
  }



  toggleSubcategories(category: FilterCategory) {
    if (category.subcategories && category.subcategories.length > 0) {
      category.showSubcategories = !category.showSubcategories;
    }
  }

  toggleCategory(category: FilterCategory) {
    // When a category is checked, check all its subcategories
    if (category.selected && category.subcategories) {
        this.toggleSubcategories(category)
      category.subcategories.forEach(subcategory => {
        subcategory.selected = true;
      });
    }
    // When a category is unchecked, uncheck all its subcategories
    else if (!category.selected && category.subcategories) {
      category.subcategories.forEach(subcategory => {
        subcategory.selected = false;
        this.toggleSubcategories(category)
      });
    }
    this.generateChips()
    
  }

  toggleSubcategory(subcategory: FilterSubcategory, category: FilterCategory) {
    // Check if all subcategories are now selected
    if (subcategory.selected && category.subcategories) {
      const allSubcategoriesSelected = category.subcategories.every(sub => sub.selected);
      if (allSubcategoriesSelected) {
        category.selected = true;
      }
    }
    // If any subcategory is unchecked, uncheck the parent category
    // else if (!subcategory.selected) {
    //   category.selected = false;
    // }
    
   
  }

  toggleValueSubcategories(value: FilterValue) {
    console.log('toggleValueSubcategories', value);
    // if (value.subcategories && value.subcategories.length > 0) {
    //   value.showSubcategories = !value.showSubcategories;
    // }
  }

  toggleValueSelection(selectedName: string) {
    console.log(selectedName,'selectedName');
    this.values.forEach(v => {
      v.selected = (v.name === selectedName);
  
      if (v.subcategories) {
        v.subcategories.forEach(sub => (sub.selected = v.selected));
      }
    });
  
    this.selectedValue = selectedName;
    this.generateChips()

    // // When a value is checked, check all its subvalues
    
  }

  // Single-select behavior via radio buttons for values list
  onValueRadioChange(event: MatRadioChange) {
    const selectedName = typeof event.value === 'string'
      ? event.value
      : event.value?.name;

    if (!selectedName) {
      return;
    }
    this.generateChips()

    this.toggleValueSelection(selectedName);
  }

  toggleSubValueSelection(subcategory: FilterSubcategory, value: FilterValue) {
    // Check if all subvalues are now selected
    if (subcategory.selected && value.subcategories) {
      const allSubvaluesSelected = value.subcategories.every(sub => sub.selected);
      if (allSubvaluesSelected) {
        value.selected = true;
      }
    }
    // If any subvalue is unchecked, uncheck the parent value
    else if (!subcategory.selected) {
      value.selected = false;
    }
    
   
  }

  clearFilter() {
    // Reset all filter properties
    this.savedFilter = {};
    this.startDate = undefined;
    this.endDate = undefined;
    this.selectedDateRange = '';
    this.selectedValue = '';
    this.conDummyArr = [];
    this.dealValues=[];
    this.selectedMember = [];
    
    // Reset categories
    if (this.categories) {
      this.categories.forEach(category => {
        category.selected = false;
        category.showSubcategories = false;
        if (category.subcategories) {
          category.subcategories.forEach(sub => {
            sub.selected = false;
          });
        }
      });
    }
    
    // Reset values
    if (this.values) {
      this.values.forEach(value => {
        value.selected = false;
      });
    }
    
    // Reset contact search
    this.contactSearchTags = '';
    
    // Remove filter-specific session storage
    const filterKey = `appliedFilters_${this.filterName}`;
    sessionStorage.removeItem(filterKey);
    this.clearFilterClicked.emit(this.filterName);
    this.closeDropdown.emit();
  }

  async applyFilter(type:any='') {
    // Collect selected categories
    const selectedCategoriesId = this.categories
      .filter(category => category.selected)
      .map(category => category.id);
  
    // Collect selected subcategories
    const selectedSubcategoryId: string[] = [];
    this.categories.forEach(category => {
      if (category.subcategories) {
        category.subcategories.forEach(subcategory => {
          if (subcategory.selected) {
            selectedSubcategoryId.push(subcategory.id);
          }
        });
      }
    });
  
    // Collect selected values (radio may set selectedValue even if flags drift)
    let values = this.values
      .filter(value => value.selected)
      .map(value => value.name);
    if ((!values || !values.length) && this.selectedValue) {
      values = [this.selectedValue];
      this.values.forEach(v => {
        v.selected = v.name === this.selectedValue;
      });
    }
  
    console.log(this.dealValues,'this.dealValuesuuuuuuuuuuuuu');
  
    let dealValues = [];
    if (this.selectedDealValuesList) {
      dealValues = this.selectedDealValuesList;
    }
  
    let Organization = [];
    if (this.selectedOrganizations?.length) {
      Organization = this.selectedOrganizations;
    }
  
    let deal_type_id = [];
    if (this.deal_type_id?.length) {
      deal_type_id = this.deal_type_id;
    }
  
    let deal_stage_id = [];
    if (this.deal_stage_id?.length) {
      deal_stage_id = this.deal_stage_id;
    }
  
    let contactSelected = [];
    if (this.selectedContacts?.length) {
      contactSelected = this.selectedContacts;
    }
  
    let itemValues;
    if (this.selectedItems) {
      itemValues = this.selectedItems;
    }
  
    let selectedTags;
    if (this.selectedCustomerIds) {
      selectedTags = this.selectedCustomerIds;
    }
  
    let selectedContactTags;
    if (this.selectedContactTags) {
      selectedContactTags = this.selectedContactTags;
    }
  
    let selectedStages;
    if (this.selectedStages) {
      selectedStages = this.selectedStages;
    }
  
    let selectedTax;
    if (this.selectedTax) {
      selectedTax = this.selectedTax;
    }
  
    let selectedDealTags;
    if (this.selectedDealIds) {
      selectedDealTags = this.selectedDealIds;
    }
  
    let selectedLeadTags;
    if (this.selectedLeadTags) {
      selectedLeadTags = this.selectedLeadTags;
    }
  
    let selectedDealTagsIds;
    if (this.selectedDealTags) {
      selectedDealTagsIds = this.selectedDealTags;
    }
  
    let contactSource;
    if (this.selectedSource) {
      contactSource = this.selectedSource;
    }
  
    let selectedLimit;
    if (this.selectedLimit) {
      selectedLimit = this.selectedLimit;
    }
  
    let region;
    if (this.selectedRegions) {
      region = this.selectedRegions;
    }
  
    let dealReasons = [];
    if (this.selectedReasons?.length) {
      dealReasons = this.selectedReasons;
    }
  
    const selectedMembers = this.selectedMember?.length ? this.selectedMember : [];
  
    // Create filter data object
    const filterData: FilterData = {
      filterName: this.filterName,
      selectedCategoriesId,
      selectedSubcategoryId,
      values,
      dealValues,
      itemValues,
      selectedTags,
      selectedContactTags,
      selectedStages,
      selectedTax,
      contactSource,
      selectedLimit,
      dealReasons,
      selectedDealTags,
      selectedLeadTags,
      selectedDealTagsIds,
      region,
      Organization,
      selectedCustomType: this.selectedCustomType,
      selectedMembers,
      contactSelected,
      deal_stage_id,
      deal_type_id,
      selectedStatus: this.selectedStatus?.length ? this.selectedStatus : [],
      selectedQuoteStatus: this.selectedQuoteStatus?.length ? this.selectedQuoteStatus : [],
      startDate: this.startDate ? new Date(this.startDate) : undefined,
      endDate: this.endDate ? new Date(this.endDate) : undefined,
      selectedDateRange: this.selectedDateRange,
      selectedMetric: this.selectedMetric || null,
      selectedInteraction: this.selectedInteraction || null,
      selectedAxis: this.selectedAxis || null,
      selectedViews: this.selectedViews || null,
    };
  
    console.log(filterData,'filterData');
    const filterKey = `appliedFilters_${this.filterName}`;
    // FIX — remove savedFilter (it restores old values)
    let existingSessionData = sessionStorage.getItem(filterKey);
    let sessionData = existingSessionData ? JSON.parse(existingSessionData) : {};
  console.log(existingSessionData,'existingSessionDataexistingSessionData');
  console.log(sessionData,'sessionDatasessionData');
  
    // Merge new filterData into session data
    sessionData = {
      ...sessionData,
      ...filterData,
      selectedCategories: selectedCategoriesId,
      selectedSubcategories: selectedSubcategoryId,
      selectedValues: values,
      startDate: this.startDate,
      endDate: this.endDate,
      selectedDateRange: this.selectedDateRange,
      selectedCustomType: this.selectedCustomType,
      selectedValue: this.selectedValue,
    };

    console.log(sessionData,'sessionDatasessionDatasessionData');
    
  
    // Save updated session data
    sessionStorage.setItem(filterKey, JSON.stringify(sessionData));
  
    if (type !== 'chip') {
      this.applyFilterClicked.emit(filterData);
      this.closeDropdown.emit();
    }
    
  }
  

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    console.log(changes,'changesCCCCCCCCCCCCCCCCCCCCC');
    
    if (changes?.regionArray) {
      this.regionArray = changes.regionArray.currentValue?.filter(
        (item, index, self) =>
          index === self.findIndex(
            (t) =>
              (t.region || t.country)?.toLowerCase().trim() ===
              (item.region || item.country)?.toLowerCase().trim()
          )
      );
    }
    
    if(changes?.contactTags){
      this.contactTags = changes?.contactTags?.currentValue?.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.id === item.id)
      );
    }
   
   await this.patchFiltersData(changes)
    
  }
  
  async patchFiltersData(changes){
    if(changes?.categories?.currentValue){
      this.categories=changes?.categories?.currentValue
      // Restore filter selections after categories are updated
      const filterKey = `appliedFilters_${this.filterName}`;
      if (sessionStorage.getItem(filterKey)) {
        this.restoreFilterSelections();
      }
    }
    if(changes?.reportFilterData){
      this.reportFilterData=changes?.reportFilterData?.currentValue
      if(this.reportFilterData?.filter_data){
        if(typeof this.reportFilterData?.filter_data =='string'){
          this.reportFilterData.filter_data=JSON.parse(this.reportFilterData?.filter_data)
        }
      }
      if (this.reportFilterData?.filter_data) {
        console.log(this.reportFilterData?.filter_data,'this.reportFilterData?.filter_data');
        
        this.selectedCustomType=this.reportFilterData?.filter_data.selectedCustomType
        if(this.reportFilterData?.filter_data?.filterName !=='Quote -to-sales-order conversion'){
          if(this.reportFilterData?.filter_data?.values?.length){
            this.values = this.values.map(v => ({
              ...v,
              selected: this.reportFilterData?.filter_data?.values.includes(v.name)
            }));
          }else{
            this.values=[
              { name: 'Quotes', selected: false },
              { name: 'Sales order', selected: false },
              { name: 'Invoices', selected: false }
            ]
          }
          
          // Restore filter selections after values are updated
          const filterKey = `appliedFilters_${this.filterName}`;
          if (sessionStorage.getItem(filterKey)) {
            this.restoreFilterSelections();
          }
        }
       
        
        
        const selectedCategories = this.reportFilterData?.filter_data.selectedCategoriesId || [];
        const selectedSubcategories = this.reportFilterData?.filter_data.selectedSubcategoryId || [];
     
        // Loop through categories
        for (const category of this.categories) {          
          if (selectedCategories.includes(category.id)) {
            category.selected = true;
        
            // Expand/show subcategories if they exist
            if (category.subcategories) {
              category.showSubcategories = true;
        
              for (const sub of category.subcategories) {
                sub.selected = selectedSubcategories.includes(sub.id);
              }
            }
          } else {
            category.selected = false;
        
            if (category.subcategories) {
              for (const sub of category.subcategories) {
                sub.selected = false;
              }
            }
          }
  
        }
  
        
      }
  
    }
  }
  
  splitValue(){
    console.log(this.savedFilter,'this.savedFilter22')
    if(this.savedFilter?.slider_value){
      if(this.savedFilter?.slider_value?.includes("-")){
        const [firstValue, secondValue] = this.savedFilter.slider_value.split("-");
        console.log(firstValue,secondValue,"secondValue secondValue secondValue")
        this.sliderMaxValue=secondValue
        this.sliderValue=firstValue
      }
    }
    
  }
  patchValues() {
    if (this.savedFilter.slider_value) {
      const [minValue, maxValue] = this.savedFilter.slider_value.split('-').map(Number);
      this.sliderValue = minValue;
      this.sliderMaxValue = maxValue;
    }
  }
  checkValueExistMember(item_arr, item) {  
    if (!Array.isArray(item_arr) || !item) {
      return false;
    }
  
    const findIndex = item_arr.findIndex(
      (obj) => obj?.fname === item?.fname && obj?.lname === item?.lname
    );
  
    return findIndex >= 0;
  }
  

  checkValueExistValues(item_arr, item) {    
    if (!Array.isArray(item_arr) || !item) {
      return false; // Return false if inputs are invalid
    }
  
    const findIndex = item_arr.findIndex(
      (obj) => obj?.value === item?.value
    );
  
    return findIndex >= 0;
  }

  getFilterSpecificSessionData() {
    const filterKey = `appliedFilters_${this.filterName}`;
    const sessionData = sessionStorage.getItem(filterKey);
    return sessionData ? JSON.parse(sessionData) : null;
  }

  async restoreFilterSelections() {
    const sessionData = this.getFilterSpecificSessionData();
    console.log(sessionData,'sessionDatasessionDatasessionDatasessionData');
    
    if (!sessionData) return;
    
    // Restore date range selection
    if (sessionData.selectedDateRange) {
      this.selectedDateRange = sessionData.selectedDateRange;
    }
    if (sessionData.selectedMetric) {
      this.selectedMetric = sessionData.selectedMetric;
    }
    if (sessionData.selectedInteraction) {
      this.selectedInteraction = sessionData.selectedInteraction;
    }
    if (sessionData.selectedAxis) {
      this.selectedAxis = sessionData.selectedAxis;
    }
    

    
    if (sessionData.selectedViews) {
      this.selectedViews = sessionData.selectedViews;
    }
    
    // if (sessionData?.selectedMembers?.length) {
    //   this.savedFilter['member'] = sessionData.selectedMembers.map(m => ({
    //     first_name: m.fname || m.first_name || '',
    //     last_name: m.lname || m.last_name || ''
    //   }));
    // } else {
    //   // No members saved in session → clear selection
    //   this.savedFilter['member'] = [];
    // }
    
    // Restore custom dates
    if (sessionData.startDate) {
      this.startDate = new Date(sessionData.startDate);
    }
    if (sessionData.endDate) {
      this.endDate = new Date(sessionData.endDate);
    }
    
    // Restore custom type selection
    if (sessionData.selectedCustomType) {
      this.selectedCustomType = sessionData.selectedCustomType;
    }
    
    // Restore selected value
    if (sessionData.selectedValue) {
      this.selectedValue = sessionData.selectedValue;
    }

    if (sessionData?.deal_type_id) {
      this.deal_type_id = sessionData.deal_type_id;
    }
  
    if (sessionData?.deal_stage_id) {
      this.deal_stage_id = sessionData.deal_stage_id;
    }
  
    // If deal_type_id exists, fetch related stages immediately
    if (this.deal_type_id.length) {
      this.getDealStage(this.deal_type_id[0]);
    }
    
    // Restore categories
    if (sessionData.selectedCategories && this.categories) {
      this.categories.forEach(category => {
        category.selected = sessionData.selectedCategories.includes(category.id);
        
        if (category.subcategories && sessionData.selectedSubcategories) {
          category.subcategories.forEach(sub => {
            sub.selected = sessionData.selectedSubcategories.includes(sub.id);
          });
          
          // Show subcategories if any are selected
          if (category.subcategories.some(sub => sub.selected)) {
            category.showSubcategories = true;
          }
        }
      });
    }
    
    // Restore values selection
    if (sessionData.selectedValues && this.values) {
      let selected
      if(Array.isArray(sessionData.selectedValues)){
        selected = sessionData.selectedValues[0]; // radio = single value

      }else{
        selected = sessionData.selectedValues;
      }
    
      // Update radio binding
      this.selectedValue = selected;
    
      // Update your internal array as well
      this.values.forEach(v => {
        v.selected = (v.name === selected);
      });
    }
    

    // 🧾 Restore Item selection
  if (sessionData.itemValues?.length && this.itemsData) {
    this.selectedItems = [...sessionData.itemValues];
  } 
  if(sessionData?.Organization){
    this.selectedOrganizations=[...sessionData?.Organization]
  }
  if(sessionData?.selectedStatus){
    console.log(sessionData?.selectedStatus,'sessionData?.selectedStatus');
    
    this.selectedStatus=[...sessionData?.selectedStatus]
    this.syncStatusSelection()
  }
  if(sessionData?.selectedQuoteStatus){
    this.selectedQuoteStatus=[...sessionData?.selectedQuoteStatus]
    this.syncQuoteStatusSelection()
  }
  
  
  if(sessionData?.contactSelected){
    this.selectedContacts=[...sessionData?.contactSelected]
  }
    // 🧾 Restore Item selection
    if (sessionData.contactSource && this.sourceOfContacts) {
      this.selectedSource  = [...sessionData.contactSource] ;
    }
    if (sessionData.selectedLimit && this.selectedLimit) {
      this.selectedLimit  = [...sessionData.selectedLimit] ;
    }
    
    if (sessionData.region?.length && this.regionArray) {
      this.selectedRegions = [...sessionData.region];
    }
    
    if (sessionData.selectedContactTags?.length) {
      console.log(sessionData.selectedContactTags,'sessionData.selectedContactTags');
      this.selectedContactTags = [...sessionData.selectedContactTags];
    }
    if (sessionData.selectedStages?.length) {
      this.selectedStages = [...sessionData.selectedStages];
    }
    if (sessionData.selectedTax?.length) {
      this.selectedTax = [...sessionData.selectedTax];
    }
    
    

    if (sessionData?.dealValues?.length) {
      const dealValue = sessionData.dealValues[0].value;
      this.singale_value.patchValue(dealValue);
    }
    if (sessionData?.selectedDealTagsIds?.length) {
      this.selectedDealTags=[...sessionData?.selectedDealTagsIds];
    }

    if (sessionData?.selectedLeadTags?.length) {
      this.selectedLeadTags=[...sessionData?.selectedLeadTags];
    }

    

    if (sessionData?.dealReasons?.length) {
      this.selectedReasons=[...sessionData?.dealReasons];
    }

    if (sessionData?.selectedMembers?.length) {
      this.selectedMember = [...sessionData.selectedMembers];
    } else {
      this.selectedMember = [];
    }
    
    

    
    // Update savedFilter for member functionality compatibility
    this.savedFilter = sessionData;
    await this.generateChips();

  }
  async generateChips() {
    const chips: { key: string; label: string; value?: any }[] = [];
  
    const push = (key: string, label: string, value?: any) => chips.push({ key, label, value });
  
    // Load item names if not loaded
    if (this.selectedItems?.length && !this.itemsData?.length) {
      await this.itemsNamesAndId();
    }
  
    // Single values
    if (this.selectedDateRange) push('selectedDateRange', this.selectedDateRange, this.selectedDateRange);
    if (this.selectedMetric) push('selectedMetric', this.selectedMetric, this.selectedMetric);
    if (this.selectedInteraction) push('selectedInteraction', this.selectedInteraction, this.selectedInteraction);
    if (this.selectedAxis) push('selectedAxis', this.selectedAxis, this.selectedAxis);
    if (this.selectedViews) push('selectedViews', this.selectedViews, this.selectedViews);
    if (this.startDate && this.endDate) push('customDates', `${this.startDate.toLocaleDateString()} - ${this.endDate.toLocaleDateString()}`, { start: this.startDate, end: this.endDate });
    if (this.selectedValue) push('selectedValue', this.selectedValue, this.selectedValue);
  
    // Arrays
    const arrayKeys = [
      { key: 'deal_type_id', data: this.deal_type_id },
      { key: 'deal_stage_id', data: this.deal_stage_id },
      { key: 'selectedOrganizations', data: this.selectedOrganizations },
      { key: 'selectedStatus', data: this.selectedStatus },
      { key: 'selectedQuoteStatus', data: this.selectedQuoteStatus },
      { key: 'selectedContacts', data: this.selectedContacts },
      { key: 'selectedSource', data: this.selectedSource },
      { key: 'selectedRegions', data: this.selectedRegions },
      { key: 'selectedContactTags', data: this.selectedContactTags },
      { key: 'selectedStages', data: this.selectedStages },
      { key: 'selectedTax', data: this.selectedTax },
      { key: 'selectedDealTags', data: this.selectedDealTags },
      { key: 'selectedLeadTags', data: this.selectedLeadTags },
      { key: 'selectedReasons', data: this.selectedReasons },
    ];
  console.log(this.selectedContactTags ,'arrayKeysarrayKeysarrayKeys',arrayKeys);
  
  arrayKeys.forEach(item => {
    if (item.key === 'selectedContactTags') {
      item.data.forEach(id => {
        const tag = this.contactTags.find(t => t.id === id);
        push(item.key, tag?.name, id); // label = name, value = id
      });
    } else {
      item.data?.forEach(val => push(item.key, val, val));
    }
  });
    // Selected Items
    if (this.selectedItems?.length && this.itemsData?.length) {
      this.selectedItems.forEach(id => {
        const item = this.itemsData.find(x => x.id === id);
        if (item) push('selectedItems', item.name, id);
      });
    }
  
    // Members
    if (this.selectedMember?.length) {
      this.selectedMember.forEach(m => push('selectedMember', m.fname || m.first_name, m.fname || m.first_name));
    }
  
    // Categories & Subcategories
    if (this.categories?.length) {
      this.categories.forEach(c => {
        if (c.selected) push('selectedCategories', c.name, c.name);
        c.subcategories?.forEach(sc => {
          if (sc.selected) push('selectedSubcategories', sc.name, sc.name);
        });
      });
    }
  
    // Deal Value
    if (this.singale_value?.value) push('dealValue', this.singale_value.value, this.singale_value.value);
  
    this.appliedChips = chips;
  }
  
  
  // Helper to format labels for array keys
  private formatKeyLabel(key: string): string {
    return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }
  
  async removeChip(key: string, value?: any) {
    switch (key) {
      case 'selectedDateRange': this.selectedDateRange = null; break;
      case 'selectedMetric': this.selectedMetric = null; break;
      case 'selectedInteraction': this.selectedInteraction = null; break;
      case 'selectedAxis': this.selectedAxis = null; break;
      case 'selectedViews': this.selectedViews = null; break;
      case 'customDates': this.startDate = null; this.endDate = null; break;
      case 'selectedCustomType': this.selectedCustomType = null; break;
      case 'selectedValue':
        this.selectedValue = null;
        if (this.values) this.values.forEach(v => v.selected = false);
        break;
      case 'deal_type_id': this.deal_type_id = value ? this.deal_type_id.filter(v => v !== value) : []; break;
      case 'deal_stage_id': this.deal_stage_id = value ? this.deal_stage_id.filter(v => v !== value) : []; break;
      case 'selectedItems': this.selectedItems = value ? this.selectedItems.filter(v => v !== value) : []; break;
      case 'selectedOrganizations': this.selectedOrganizations = value ? this.selectedOrganizations.filter(v => v !== value) : []; break;
      case 'selectedStatus': this.selectedStatus = value ? this.selectedStatus.filter(v => v !== value) : []; break;
      case 'selectedQuoteStatus': this.selectedQuoteStatus = value ? this.selectedQuoteStatus.filter(v => v !== value) : []; break;
      case 'selectedContacts': this.selectedContacts = value ? this.selectedContacts.filter(v => v !== value) : []; break;
      case 'selectedSource': this.selectedSource = value ? this.selectedSource.filter(v => v !== value) : []; break;
      case 'selectedLimit': this.selectedLimit = null; break;
      case 'selectedRegions': this.selectedRegions = value ? this.selectedRegions.filter(v => v !== value) : []; break;
      case 'selectedContactTags': this.selectedContactTags = value ? this.selectedContactTags.filter(v => v !== value) : []; break;
      case 'selectedStages': this.selectedStages = value ? this.selectedStages.filter(v => v !== value) : []; break;
      case 'selectedTax': this.selectedTax = value ? this.selectedTax.filter(v => v !== value) : []; break;
      case 'selectedDealTags': this.selectedDealTags = value ? this.selectedDealTags.filter(v => v !== value) : []; break;
      case 'selectedLeadTags': this.selectedLeadTags = value ? this.selectedLeadTags.filter(v => v !== value) : []; break;
      case 'selectedReasons': this.selectedReasons = value ? this.selectedReasons.filter(v => v !== value) : []; break;
      case 'selectedMember': this.selectedMember = value ? this.selectedMember.filter(v => (v.fname || v.first_name) !== value) : []; break;
      case 'dealValue': this.singale_value.patchValue(''); break;
      case 'selectedCategories':
        if (value) {
          this.categories.forEach(c => { if (c.name === value) c.selected = false; c.subcategories?.forEach(sc => { if (sc.name === value) sc.selected = false; }); });
        } else {
          this.categories.forEach(c => c.selected = false);
          this.categories.forEach(c => c.subcategories?.forEach(sc => sc.selected = false));
        }
        break;
    }
  
    // Update session storage
    const filterKey = `appliedFilters_${this.filterName}`;
    const sessionDataRaw = sessionStorage.getItem(filterKey);
    const sessionData = sessionDataRaw ? JSON.parse(sessionDataRaw) : {};
  
    if (sessionData[key] !== undefined) {
      if (Array.isArray(sessionData[key])) {
        sessionData[key] = value ? sessionData[key].filter((v: any) => v !== value) : [];
      } else {
        sessionData[key] = null;
      }
    }
  
    sessionStorage.setItem(filterKey, JSON.stringify(sessionData));
  
    // Regenerate chips
    await this.generateChips();
  }
  
  
  
  
  
  

  getAccorValue(event: any, value: any, from: any) {
    console.log(event?.checked, 'event?.checked', value, 'vvvvvaaaaaaaal', from, 'ffffffrrrrrooooooo');
    
    if (from === 'member') {
      // Temporary local variable to store selected member
      if (event?.checked) {
        this.selectedMember = [{
          id: value?.id || '',
          fname: value?.fname || '',
          lname: value?.lname || ''
        }];
      } else {
        this.selectedMember = [];
      }
  
      console.log(this.selectedMember, 'this.selectedMember (temporary)');
    }
  
    if (from === 'value') {
      this.dealValues = [];
      if (event?.checked) {
        this.dealValues = [{ value: value?.value }];
      }
      this.savedFilter['dealValue'] = this.dealValues;
      console.log(this.savedFilter, 'this.savedFilter (value)');
    }
    this.generateChips()

  }
  

  getLostReasons(){
    this.tasksService.getReasonList({ reasonType: "lost" }).subscribe(async (result) => {
      if(result?.data){
        this.dealReasonsList=result?.data
      }
      console.log(result,'resultresultresultresultresultresultresult');
      

    })
  }


isSelected(item: any): boolean {
  return this.selectedReasons.some(r => r.id === item.id);
}

toggleReason(event: any, item: any) {
  if (event.checked) {
    // Add if not already in the list
    if (!this.isSelected(item)) {
      this.selectedReasons.push({ id: item.id, reason: item.reason });
    }
  } else {
    // Remove if unchecked
    this.selectedReasons = this.selectedReasons.filter(r => r.id !== item.id);
  }
  this.generateChips()

  console.log("Selected Reasons:", this.selectedReasons);
}

isContactValueSelected(tagId: number): boolean {
  return this.selectedContactTags.includes(tagId);
}

isStagesSelected(tagId: number): boolean {
  return this.selectedStages.includes(tagId);
}

toggleStagesValue(event: any, item: any): void {
  if (event.checked) {
    this.selectedStages.push(item.id);

  } else {
    this.selectedStages = this.selectedStages.filter(id => id !== item.id);

  }
  this.generateChips()

}

isSalesTaxSelected(name: any): boolean {
  return this.selectedTax.includes(name);
}

toggleSalesTaxValue(event: any, item: any): void {
  if (event.checked) {
    this.selectedTax.push(item.name);

  } else {
    this.selectedTax = this.selectedTax.filter(id => id !== item.name);

  }
  this.generateChips()

}

toggleContactValue(event: any, item: any): void {
  if (event.checked) {
    // ✅ Track tag.id for UI selection
    this.selectedContactTags.push(item.id);

    // ✅ Also push customer_id for payload
    this.selectedCustomerIds.push(item.customer_id);
  } else {
    // remove tag.id
    this.selectedContactTags = this.selectedContactTags.filter(id => id !== item.id);

    // remove customer_id
    this.selectedCustomerIds = this.selectedCustomerIds.filter(id => id !== item.customer_id);
  }
  this.generateChips()
}



isItemsValueSelected(itemId: number): boolean {
  return this.selectedItems.includes(itemId);
}

toggleItemsValue(event: any, item: any): void {
  if (event.checked) {
    // add item id
    this.selectedItems.push(item.id);
  } else {
    // remove item id
    this.selectedItems = this.selectedItems.filter(id => id !== item.id);
  }
  this.generateChips()
}

isSourceValueSelected(itemId: number): boolean {
  return this.selectedSource.includes(itemId);
}

toggleSourceValue(event: any, item: any): void {
  if (event.checked) {
    // add item id
    this.selectedSource.push(item.name);
  } else {
    // remove item id
    this.selectedSource = this.selectedSource.filter(id => id !== item.name);
  }
  this.generateChips()

}

isLimitValueSelected(itemId: number): boolean {
  return this.selectedLimit.includes(itemId);
}

toggleLimitValue(event: any, item: any): void {
  if (event.checked) {
    // Clear previous selections and push the new one
    this.selectedLimit = [item.name];
  } else {
    // Remove the value if unchecked
    this.selectedLimit = [];
  }
  this.generateChips()

  console.log('Selected Limit Array:', this.selectedLimit);
}

isRegionSelected(region: string): boolean {
  return this.selectedRegions.includes(region);
}

toggleRegionSelection(event: any, item: any): void {
  if (event.checked) {
    if (!this.selectedRegions.includes(item.region)) {
      this.selectedRegions.push(item.region);
    }
  } else {
    this.selectedRegions = this.selectedRegions.filter(r => r !== item.region);
  }
  this.generateChips()

}


isValueSelected(item: any): boolean {
  return this.selectedDealValuesList.some(v => v.value === item.value);
}

toggleDealValue(event: any, value: any | string, type: string) {
  const numericValue = Number(value);

  // Clear previous selection
  this.selectedDealValuesList = [];

  if (!isNaN(numericValue) && numericValue > 0) {
    this.selectedDealValuesList.push({ value: numericValue.toString() });
  }
  this.generateChips()
  console.log("Selected Deal Values:", this.selectedDealValuesList);
}


async itemsNamesAndId() {
  return new Promise<void>((resolve, reject) => {
    this.itemsService.filterItems().subscribe({
      next: (res) => {
        if (res?.data?.length) {
          this.itemsData = res.data;

          // Restore item selection AFTER items loaded
          const sessionData = this.getFilterSpecificSessionData();

          if (sessionData?.itemValues?.length) {
            this.selectedItems = [...sessionData.itemValues];
            this.generateChips();
          }
        }

        resolve(); // <-- correct position
      },

      error: (err) => reject(err),
    });
  });
}



async contactSourceList() {
  const cateogryListSubs = this.itemsService.formContactList().subscribe(async (res) => {
    if(res?.data?.length){
      console.log(res,'resresresresresresresresresuuuuxxxxxxxx');
      this.sourceOfContacts=res.data
    }
  
    
  });
}

getTags() {
  this.itemsService.getTagsList().subscribe((res: any) => {
    console.log(res,'resresresresresresuuuuuuuu456789');
    if(res?.data){
      this.allTagsArr =  res?.data;

    }
  }, (error) => { });

}

isDealTagsValueSelected(tagId: number): boolean {
  return this.selectedDealTags.includes(tagId);
}

isLeadTagsValueSelected(tagId: number): boolean {
  return this.selectedLeadTags.includes(tagId);
}

toggleDealTagsValue(event: any, item: any): void {
  if (event.checked) {
    // ✅ Track tag.id for UI selection
    this.selectedDealTags.push(item.id);

    // ✅ Also push customer_id for payload
    this.selectedDealIds.push(item.merchant_lead_deal_id);
  } else {
    // remove tag.id
    this.selectedDealTags = this.selectedDealTags.filter(id => id !== item.id);

    // remove customer_id
    this.selectedDealIds = this.selectedDealIds.filter(id => id !== item.merchant_lead_deal_id);
  }
  this.generateChips()

}

toggleLeadTagsValue(event: any, item: any): void {
  if (event.checked) {
    // ✅ Track tag.id for UI selection
    this.selectedLeadTags.push(item.id);


  } else {
    this.selectedLeadTags = this.selectedLeadTags.filter(id => id !== item.id);

  }
  this.generateChips()

}

getOrgList() {
  this.leadService.getOrganizationList().pipe(takeUntil(this._unsubscribeAll)).subscribe(
    (res: any) => {
      const savedOrgs = this.savedFilter?.organization || [];
      this.allOrgArr = res?.data.map(org => ({
        ...org,
        checked: savedOrgs.length > 0 && this.checkIfNameMatches(org?.name, savedOrgs)
      }));
    },
    (error) => { 
      console.error(error);
    }
  );
}

checkIfNameMatches(name: string, savedOrgs: any[]): boolean {
  return savedOrgs.some(org => org?.name === name);
}


selectedOrganizations: { id: any; name: string }[] = [];

getAccorValueOrganization(event: any, org: { id: any; name: string }, type: string) {
  if (type !== 'organization') return;

  if (event.checked) {
    // Add organization if not already in the list
    if (!this.selectedOrganizations.some(o => o.id === org.id)) {
      this.selectedOrganizations.push(org);
    }
  } else {
    // Remove organization if unchecked
    this.selectedOrganizations = this.selectedOrganizations.filter(o => o.id !== org.id);
  }
  this.generateChips()

  console.log('Selected Organizations:', this.selectedOrganizations);
}

async getMerchantCustomerNew(limit: any = '') {
  $('#multipleCheck').prop('checked', false);

  // Prepare search parameters
  this.serchArr = {
    pagination: true,
    limit: limit !== '' ? 100 : this.page?.pageSize || 100,
    page: limit !== '' ? 1 : this.page?.currentPage || 1,
    whereFilterData: this.where,
    search: this.globalSearchText || '',
    sortField: this.sortField,
    sortOrder: this.sortOrder,
  };

  const getCustomerSubs = this.contactService.getCustomer(this.serchArr).pipe(takeUntil(this._unsubscribeAll)).subscribe({
    next: (result) => {
      if (!result || result.create === false) return;

      // Sort alphabetically by firstname (case-insensitive)
      const sortedData = result.data.sort((a, b) =>
        a.firstname.toLowerCase().localeCompare(b.firstname.toLowerCase())
      );

      // ✅ Mark as checked if already selected
      const mappedData = sortedData.map((item: any) => {
        const isAlreadySelected = this.selectedContacts?.some(
          (c: any) => c.id === item.id
        );
        return {
          ...item,
          checked: isAlreadySelected
        };
      });

      // Assign both original and working arrays
      this.originalMerContactListArr = [...mappedData];
      this.merContactListArrNew = [...mappedData];

      // Update pagination info
      this.page = {
        ...this.page,
        numberOfPages: result?.totalPages,
        totalItems: result?.totalCount,
        currentPage: result?.currentPage,
      };

      this.currentPage = result.currentPage;
      this.limit = result.totalCount;
      this.itemActivePagination = new Array(result.totalPages);
      this.openBulkAction = false;

      this.spinnerService.hide();
    },
    error: () => {
      this.spinnerService.hide();
    },
  });
}

loadAllOnScroll(page: number) {
  this.serchArr = {
    pagination: true,
    limit: this.page?.pageSize || 100,
    page: page + 1 || 1,
    whereFilterData: this.where,
    search: this.globalSearchText || '',
    sortField: this.sortField,
    sortOrder: this.sortOrder,
  };

  const getCustomerSubs = this.contactService.getCustomer(this.serchArr).pipe(takeUntil(this._unsubscribeAll)).subscribe({
    next: (result) => {
      if (!result) return;

      this.currentPage = result.currentPage;

      const newData = result.data.sort((a, b) =>
        a.firstname.toLowerCase().localeCompare(b.firstname.toLowerCase())
      );

      // ✅ Mark as checked if already selected, avoid duplicates
      const mappedNewData = newData
        .filter((item: any) => !this.merContactListArrNew.some(e => e.id === item.id))
        .map((item: any) => {
          const isAlreadySelected = this.selectedContacts?.some(
            (c: any) => c.id === item.id
          );
          return {
            ...item,
            checked: isAlreadySelected
          };
        });

      // Append new data to the existing list
      this.merContactListArrNew = [
        ...this.merContactListArrNew,
        ...mappedNewData
      ];
    },
  });
}


getAccorValueContact(event: any, contact: { id: any; firstname: string; lastname?: string }, type: string) {
  if (type !== 'contact') return;

  if (event.checked) {
    // Add contact if not already in the list
    if (!this.selectedContacts.some(c => c.id === contact.id)) {
      this.selectedContacts.push({
        id: contact.id,
        name: `${contact.firstname || ''} ${contact.lastname || ''}`.trim()
      });
    }
  } else {
    // Remove contact if unchecked
    this.selectedContacts = this.selectedContacts.filter(c => c.id !== contact.id);
  }
  this.generateChips()

  console.log('Selected Contacts:', this.selectedContacts);
}

getstatusValue(event: any, status: { id: any; name: string }, type: string) {
  if (type !== 'organization') return;

  if (event.checked) {
    // ✅ Add if not already selected
    if (!this.selectedStatus.some(s => s.id === status.id)) {
      this.selectedStatus.push(status);
    }
  } else {
    // ❌ Remove if unchecked
    this.selectedStatus = this.selectedStatus.filter(s => s.id !== status.id);
  }
  this.generateChips()

  console.log('Selected Status:', this.selectedStatus);
}

// ✅ Call this whenever the filter data is loaded or refreshed
syncStatusSelection() {
  this.accountStatementStatusFilter = this.accountStatementStatusFilter.map(item => ({
    ...item,
    checked: this.selectedStatus.some(selected => selected.id === item.id)
  }));
}

getDealType() {
  this.leadService.getDealTypeList().pipe(takeUntil(this._unsubscribeAll)).subscribe({
    next: (res: any) => {
      this.deal_typeArr = res?.data || [];
     
    },
    error: (err) => {
      console.error('Error loading deal types:', err);
    },
  });
}


getUniqueTags(tags: any[], property: string): any[] {
  if (!Array.isArray(tags) || tags.length === 0) return [];
  const seen = new Set<string>();
  return tags.filter(tag => {
    const propValue = tag?.[property];
    if (propValue && !seen.has(propValue)) {
      seen.add(propValue);
      return true;
    }
    return false;
  });
}

deal_type_id: string[] = [];
deal_stage_id: string[] = [];

getDealTypeData(event: any, value: any, from: string) {
  if (from !== 'deal_type') return;

  // ✅ Clear previous selections
  this.deal_stageArr = [];
  this.deal_stage_id = [];

  // ✅ Save selected deal type
  this.deal_type_id = [value?.id];

  // 🔄 Fetch related deal stages
  this.getDealStage(value?.id);
  this.generateChips()

}

getDealStage(id: string) {
  this.leadService.dealStageList({ deal_type_id: id }).pipe(takeUntil(this._unsubscribeAll)).subscribe({
    next: (res: any) => {
      this.deal_stageArr = res?.data || [];
    },
    error: (err) => {
      console.error('Error fetching deal stages:', err);
      this.deal_stageArr = [];
    }
  });
}

getDealStageData(event: any, stage: any, from: string) {
  if (from !== 'deal_stage') return;

  if (event.checked) {
    // ✅ Add stage ID if not already selected
    if (!this.deal_stage_id.includes(stage.id)) {
      this.deal_stage_id.push(stage.id);
    }
  } else {
    // ❌ Remove stage ID if unchecked
    this.deal_stage_id = this.deal_stage_id.filter(id => id !== stage.id);
  }
  this.generateChips()

  console.log('✅ deal_type_id:', this.deal_type_id);
  console.log('✅ deal_stage_id:', this.deal_stage_id);
}


getTranslatedText(key: string): string {
  const translation = this.translateService.instant(key);
  return translation !== key ? translation : '';
}

checkValueExist(item_arr, item) {
  let findIndex = item_arr?.findIndex((obj) => obj?.id === item);    
  return findIndex >= 0;
}

getQuoteStatusValue(event: any, status: { id: any; name: string }, type: string) {
  if (type !== 'organization') return;

  if (event.checked) {
    // ✅ Add if not already selected
    if (!this.selectedQuoteStatus.some(s => s.id === status.id)) {
      this.selectedQuoteStatus.push(status);
    }
  } else {
    // ❌ Remove if unchecked
    this.selectedQuoteStatus = this.selectedQuoteStatus.filter(s => s.id !== status.id);
  }
  this.generateChips()

  console.log('Selected Status:', this.selectedQuoteStatus);
}

syncQuoteStatusSelection() {
  this.quoteBySourceStatusFilters= this.quoteBySourceStatusFilters.map(item => ({
    ...item,
    checked: this.selectedQuoteStatus.some(selected => selected.id === item.id)
  }));
}

async getQuoteStages() {
  this.spinnerService.show();
  this.QuoteTemplateServices.get_Quote_Stages().pipe(takeUntil(this._unsubscribeAll)).subscribe({
    next: (resp) => {
      this.spinnerService.hide();
      if (resp) {
        this.allQuoteStagesList = resp?.data;
        this.allQuoteStagesList = this.allQuoteStagesList.sort(
          (a, b) => a?.order - b?.order
        );
      console.log(this.allQuoteStagesList,'this.allQuoteStagesList');
      
      }
    },
    error: (err) => {
      console.log('got error : ', err);
    },
  });
}

getTagsLeads() {
  this.leadService.getTagsList().pipe(takeUntil(this._unsubscribeAll)).subscribe((res: any) => {
    // this.tagsArr = res ? this.getUniqueTags(res.data, 'name') : null;
    this.allLeadsTagsArr =  res?.data;
    console.log(this.allLeadsTagsArr,'this.allLeadsTagsArr');
    
  }, (error) => { });

}

async getTaxList() {
  const getTaxesListSubs = this.itemsService.getTaxesList({ module_name: 'items', dropdown_name: 'taxes' }).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
    console.log(res,'resresresres');
    
    if (res.data?.length) {
      const getTaxCustomValuesSubs = this.itemsService.itemTexCustomValuess().pipe(takeUntil(this._unsubscribeAll)).subscribe(ress => {
        console.log(ress,'ressress88888888888');
        
        if(ress?.results?.length){
          res.data.forEach((item: any) => {
            // Find corresponding element in results array based on customValueId
            const resultItem = ress?.results.find((result: any) => result.customValueId === item.id);
        
            // If corresponding element is found, update taxe_value
            if (resultItem) {
              item.taxe_values = resultItem.taxe_value;
            }
          });
        }
        
      });
    }
    
    this.taxListArr = res.data;
    console.log(this.taxListArr,'this.taxListArr');
    
  });
}

onMetricSelectionChange(event: any): void {
  this.selectedMetric = event.value;
  console.log('Selected Metric:', this.selectedMetric);
  this.generateChips()

  // Add your logic for selected metric
  // Example:
  // if (this.selectedMetric === 'Top sellers') { this.loadTopSellers(); }
}

onInteractionSelectionChange(event: any): void {
  this.selectedInteraction = event.value;
  console.log('Selected Metric:', this.selectedInteraction);
  this.generateChips()

  // Add your logic for selected metric
  // Example:
  // if (this.selectedMetric === 'Top sellers') { this.loadTopSellers(); }
}
onAxisSelectionChange(event: any): void {
  this.selectedAxis = event.value;
  console.log('Selected Metric: selectedAxis', this.selectedAxis);
  this.generateChips()

  // Add your logic for selected metric
  // Example:
  // if (this.selectedMetric === 'Top sellers') { this.loadTopSellers(); }
}


onViewsSelectionChange(event: any): void {
  this.selectedViews = event.value;
  console.log('Selected Metric:', this.selectedViews);

  // Add your logic for selected metric
  // Example:
  // if (this.selectedMetric === 'Top sellers') { this.loadTopSellers(); }
}

async getCurrency() {
  const currencySubs = await this.businessProfileService
    .currency()
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe((val: any) => {
      if (val) {
        console.log(val.data,'val.dataval.dataval.data');
        
        this.currencyArr = val.data;
        this.filteredCurrency = val.data;
       
      }
    });
}

onSearchValueChange(value: string) {
  if (value == '') {
    this.currencyArr = this.filteredCurrency;
  } else {
    this.currencyArr = this.currencyArr.filter(
      (option) =>
        option.currency_code.toLowerCase().includes(value.toLowerCase()) ||
        option.currency_symbol.toLowerCase().includes(value.toLowerCase())
    );
  }
}

setYAxisOptions() {
  let quantityLabel = 'Sales Orders (Quantity)'; // default

  switch (this.filterName) {
    case 'Top customers':
      quantityLabel = 'Top Customers (Quantity)';
      break;
    case 'New Quotes':
      quantityLabel = 'New Quotes (Quantity)';
      break;
    case 'New Leads':
      quantityLabel = 'New Leads (Quantity)';
      break;
    case 'Quote -to-sales-order conversion':
      quantityLabel = 'Quote-to-Sales Orders (Quantity)';
      break;
    case 'Sales Order':
      quantityLabel = 'Sales Orders (Quantity)';
      break;
  }

  this.yAxis[1].label = quantityLabel;

  this.selectedAxis = this.selectedAxis || '';
}

  ngOnDestroy(): void {
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }
}
